export default __webpack_public_path__ + "static/nest-92b642aab5791a1b2c41c1447630b23e.png";